import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=5c5680be&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=js&"
export * from "./breadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=5c5680be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5680be",
  null
  
)

export default component.exports